import { render, staticRenderFns } from "./languemodale.vue?vue&type=template&id=21a25fff&scoped=true"
import script from "./languemodale.vue?vue&type=script&lang=js"
export * from "./languemodale.vue?vue&type=script&lang=js"
import style0 from "./languemodale.vue?vue&type=style&index=0&id=21a25fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a25fff",
  null
  
)

export default component.exports